export default __webpack_public_path__ + "static/media/hcl.1bc9649e.jpg";